// test2357
(2357 && 0);
